"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rand_1 = require("../rand");
var process_1 = require("../process");
exports.substitute = function (input) {
    if (process_1.isProcessedWord(input)) {
        if (input.length <= 2) {
            return input;
        }
        var place = rand_1.sample(input);
        var placeIndex = input.indexOf(place);
        var swap = input[placeIndex + 1] || input[placeIndex - 1];
        var swapIndex = input.indexOf(swap);
        var isAtEnd = placeIndex > swapIndex;
        if (!swap) {
            return input;
        }
        var reordered_1 = __spreadArrays(input.slice(0, isAtEnd ? swapIndex : placeIndex), (isAtEnd ? [place, swap] : [swap, place]), (isAtEnd ? [] : input.slice(swapIndex + 1)));
        return input.map(function (processedCharacter, i) { return (__assign(__assign({}, processedCharacter), { transformed: reordered_1[i].transformed })); });
    }
    return input;
};
